import { DateTime } from 'luxon'
import { type GameData, type GameRelevanceGroup } from '@terros/common'
import { type TranslateFunction } from '@front/model'

type Props = {
  game: Pick<GameData, 'startDate' | 'endDate'>
  group: GameRelevanceGroup
  now: number
  t: TranslateFunction
}

function relativeTo(timestamp: number, now: number): string {
  return DateTime.fromMillis(timestamp).toRelative({ base: DateTime.fromMillis(now) }) ?? ''
}

/** A game ended early keeps its scheduled `endDate`, which is still ahead of us, so it only says it ended. */
export function toCompetitionTiming({ game, group, now, t }: Props): string {
  switch (group) {
    case 'current':
      return t('Ends {{when}}', { when: relativeTo(game.endDate, now) })
    case 'recentlyEnded':
    case 'earlier':
      if (game.endDate > now) return t('Ended')
      return t('Ended {{when}}', { when: relativeTo(game.endDate, now) })
    case 'upcomingSoon':
    case 'upcomingLater':
      return t('Starts {{when}}', { when: relativeTo(game.startDate, now) })
  }
}
